export const LucideType = 'lucide';
